import { Key, History, Users, UserCircle, User, LogOut, Settings } from "lucide-react"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "@/components/ui/sidebar"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import { supabase } from "@/integrations/supabase/client"
import { useToast } from "@/components/ui/use-toast"

const menuItems = [
  {
    title: "Gestion des clés",
    icon: Key,
    url: "/",
  },
  {
    title: "Historique",
    icon: History,
    url: "/history",
  },
  {
    title: "Utilisateurs",
    icon: Users,
    url: "/users",
  },
  {
    title: "Paramètres",
    icon: Settings,
    url: "/settings",
  },
]

export function AppSidebar() {
  const location = useLocation()
  const [userName, setUserName] = useState<string>("")
  const { toast } = useToast()

  useEffect(() => {
    const fetchUserProfile = async () => {
      const { data: { user } } = await supabase.auth.getUser()
      if (user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('first_name, last_name')
          .eq('id', user.id)
          .single()
        
        if (profile) {
          const fullName = `${profile.first_name} ${profile.last_name}`.trim()
          setUserName(fullName)
        }
      }
    }

    fetchUserProfile()
  }, [])

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut()
      toast({
        title: "Déconnexion réussie",
        description: "Vous avez été déconnecté avec succès.",
      })
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error)
      toast({
        title: "Erreur de déconnexion",
        description: "Une erreur est survenue lors de la déconnexion.",
        variant: "destructive",
      })
    }
  }

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="p-4">
        <h2 className="text-lg font-semibold text-[#4A4A4A] group-data-[collapsible=icon]:hidden">Keynest Hotel Célia</h2>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="text-sm text-[#4A4A4A]/70">Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    className="hover:bg-[#F0F0F0] hover:text-[#00ADB5] data-[active=true]:bg-[#F0F0F0] data-[active=true]:text-[#00ADB5]"
                    data-active={location.pathname === item.url}
                  >
                    <a href={item.url} className="flex items-center gap-2 text-[#4A4A4A]">
                      <item.icon className="h-4 w-4" />
                      <span className="text-sm">{item.title}</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="mt-auto p-4">
        <SidebarSeparator />
        <div className="mt-4 space-y-4">
          <a 
            href="/profile" 
            className="flex items-center gap-2 px-2 text-[#4A4A4A] hover:bg-[#F0F0F0] hover:text-[#00ADB5] rounded-md py-2"
            data-active={location.pathname === '/profile'}
          >
            <User className="h-4 w-4" />
            <span className="text-sm group-data-[collapsible=icon]:hidden">{userName}</span>
          </a>
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-2 rounded-md px-2 py-2 text-[#4A4A4A] hover:bg-[#F0F0F0] hover:text-[#00ADB5]"
          >
            <LogOut className="h-4 w-4" />
            <span className="text-sm group-data-[collapsible=icon]:hidden">Déconnexion</span>
          </button>
        </div>
      </SidebarFooter>
    </Sidebar>
  )
}